export default __webpack_public_path__ + "static/media/fond-val_pan_2.6761c922.png";